import * as s from "./AlertViewStyled";
import { Text } from "components/atoms/text/Text";
import CLOSE_ICON from "assets/icons/sidenav/x.svg";
import {
  AlertType,
  AlertViewInfo,
} from "api/interfaces/alertInterface.interface";

import Type from "components/atoms/text/labels/Type";
import { useAppSelector } from "redux/hooks";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import WebAppLink from "components/blocks/link/WebAppLink";
import { useQueryClient } from "react-query";
import { convertType } from "utils/functions";
import TinyButton from "components/atoms/buttons/TinyButton";
import RBACWrapper from "components/blocks/function/RBACWrapper";
import useAccountAccess from "hook/useAccountAccess";

interface AlertViewHeaderProps {
  alertInfo: AlertViewInfo | null;
  alertTypeList: AlertType[];
  isModal?: boolean;
  isHistoryOrModal?: boolean;
  onModal?: () => void;
  onCloseAllStatus: () => void;
  onSwitchAccount?: (accountId: string) => void;
}

const AlertViewHeader = (props: AlertViewHeaderProps) => {
  const queryClient = useQueryClient();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { AccountAccessButton, AccountAccessModal } = useAccountAccess({
    buttonType: "RecorderAccountButton",
    useTemporary: false,
    isShowOnlyUser: true,
    toPath: "/recorders/list",
  });
  return (
    <s.AlertModalHeader>
      {props.isModal && (
        <s.CloseButton
          onClick={() => {
            props.onModal && props.onModal();
            queryClient.invalidateQueries("activeAlert");
          }}
          data-testid="alert-view-view-close-button-modal"
        >
          <img alt="close button" src={CLOSE_ICON} />
        </s.CloseButton>
      )}

      {(props.alertInfo?.accountInfo || []).length > 0 &&
        selectedAccount.accountLevel !== LEVEL_TYPE.EU && (
          <s.AccountInfoListWrapper
            className={`detail ${props.isModal ? "modal" : ""}`}
          >
            {(props.alertInfo?.accountInfo || []).map((account, index) => (
              <AccountAccessButton
                accountId={account.accountId}
                key={account.accountId}
                accountName={account.accountName}
                accountNumber={account.accountNumber ?? ""}
                level={account.level}
                index={index}
              />
            ))}
          </s.AccountInfoListWrapper>
        )}

      <s.HeaderInner isModal={props.isModal}>
        {props.alertInfo && (
          <s.HeaderSub isModal={props.isModal}>
            <Type
              type={convertType(props.alertInfo)}
              licenseType={props.alertInfo.licenseType}
              isCloudCam={props.alertInfo.isCloudCam}
            />

            <div className="system-title">
              <Text bold className="system-name" fontSize={24}>
                {props.alertInfo.mergedSystemName ??
                  props.alertInfo.recorderName}
              </Text>
              {props.alertInfo.type === "Spectrum" && (
                <Text fontSize={14} color="#828B9B" className="server-name">
                  {props.alertInfo.recorderName}
                </Text>
              )}

              <div className="web-app-link-wrapper">
                <WebAppLink
                  {...props.alertInfo}
                  displayType={convertType(props.alertInfo)}
                  accountId={selectedAccount.accountId}
                />
              </div>
            </div>

            {!props.isModal &&
              !(
                props.alertTypeList?.length === 1 &&
                props.alertTypeList[0].status === "Closed"
              ) && (
                <RBACWrapper requiredPermissions={"manageAlertRules"}>
                  <s.AlertStatusStyled.AlertStatusChange>
                    <TinyButton
                      onClickBtn={props.onCloseAllStatus}
                      label={props.isHistoryOrModal ? "CLOSE" : "CLOSE ALL"}
                      buttonType="warning"
                      data-testid="alert-view-view-tiny-button-close-all-status"
                    />
                  </s.AlertStatusStyled.AlertStatusChange>
                </RBACWrapper>
              )}
          </s.HeaderSub>
        )}
      </s.HeaderInner>
      {AccountAccessModal}
    </s.AlertModalHeader>
  );
};

export default AlertViewHeader;
